import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 35000-35999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const chatErrors = {
  // 35xxx is the chat module's series — the CUBE AI assistant, NOT portalChat (21xxx). Its
  // conversations are a different resource, so PORTAL_CHAT_CONVERSATION_NOT_FOUND (21001) is not
  // reused here.
  // 35001-35005 — the chat (CUBE AI) module's split.
  CHAT_CONVERSATION_ID_INVALID: {
    errorCode: 35001,
    errorMessage: t("Invalid conversation id."),
    isDynamic: false,
  },
  CHAT_CONVERSATION_NOT_FOUND: {
    errorCode: 35002,
    errorMessage: t("Conversation not found."),
    isDynamic: false,
  },
  // `configError()` reads as dynamic but returns one fixed sentence, so it migrates like any
  // literal rather than taking the dynamic-message deferral.
  CHAT_NOT_CONFIGURED: {
    errorCode: 35003,
    errorMessage: t("CUBE AI is not configured. Missing ANTHROPIC_API_KEY."),
    isDynamic: false,
  },
  CHAT_UNAVAILABLE: {
    errorCode: 35004,
    errorMessage: t("Sorry, CUBE AI is temporarily unavailable."),
    isDynamic: false,
  },
  CHAT_NO_PENDING_ACTION: {
    errorCode: 35005,
    errorMessage: t("There is no pending action to approve."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
